"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toBn = _interopRequireDefault(require("../hex/toBn"));

// Copyright 2017-2020 @polkadot/util authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name bnFromHex
 * @summary Creates a BN.js bignumber object from a hex string.
 * @alias hex/toBn
 */
var _default = _toBn.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/util/bn/fromHex.js
// module id = ./node_modules/@polkadot/util/bn/fromHex.js
// module chunks = 0